<script>
import axios from "axios";
import router from "@/router";
/*import logoutButton from './logout-button';*/
import Header from "@/components/front/Header";
import Footer from "@/components/front/Footer";
import progressContainer  from './progressContainer.vue';
import { us_states } from "@/state/helpers";
import { required, email, numeric } from "vuelidate/lib/validators";
import moment from 'moment';

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  components: { /*logoutButton ,*/ Header, Footer, progressContainer },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      userData: JSON.parse(localStorage.getItem("web_user")),
      gender: [
        { value: "male", text: "Male" },
        { value: "female", text: "Female" },
      ],
      age: null,
      ageError: false,
      states: [],
      backToOverview: false,
      addContactInfoForm: {
        first_name: "",
        middle_name: "",
        last_name: "",
        DOB: "",
        gender: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip_code: "",
        email: "",
        mobile: "",
        phone: "",
      },
      typeSubmit: false,
      middleNameAvailability: 'available',
      isMiddleNameAvailable: true,
    };
  },
  validations: {
    addContactInfoForm: {
      first_name: { required },
      middle_name: { required },
      last_name: { required },
      DOB: { required },
      gender: { required },
      address: { required },
      city: { required },
      state: { required },
      zip_code: { required, numeric },
      email: { required, email },
      phone: { required },
    },
  },
  mounted() {
    this.getContactDetail();
    this.getSubmitFormStats();
    this.setStatesProps();
  },
  methods: {
    contact() {
      router.push({ name: "contact" });
    },

    dateDisabled(ymd, date) {
      return date > new Date();
    },

    // set states
    setStatesProps() {
      us_states.forEach((state) => {
        this.states.push({ value: state, text: state });
      });
    },
    skipToReview() {
      router.push({ name: "review-application" });
    },

    addContactInfo() {
      const userData = JSON.parse(localStorage.getItem("web_user"));
      var config = {
        headers: { Authorization: "Bearer " + userData.token },
      };
      this.typeSubmit = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.addContactInfoForm.DOB = moment(this.addContactInfoForm.DOB, 'MM-DD-YYYY').format('YYYY-MM-DD');
        if (this.userData.user_type_id === 3) {
          // console.log(this.age);
          // if(this.age >= 25){
          if (userData.token) {
            axios
              .post("user/update/profile", this.addContactInfoForm, config)
              .then((res) => {
                if (res) {
                  // if mentor
                  router.push({ name: "background-check" });
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              });
          }
          // }else{
          //     alert("Mentors must be 25 year or older");
          // }
        } else {
          // if volunteer
          if (userData.token) {
            axios
              .post("user/update/profile", this.addContactInfoForm, config)
              .then((res) => {
                if (res) {
                  // if volunteer
                  if( userData.is_mentor ) {
                    router.push({ name: "background-check" });
                  } else {
                    router.push({ name: "questions" });
                  }
                }
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response.data.error.message);
                }
              });
          }
        }
      }
    },
    // Getting Current User Forms States
    getSubmitFormStats() {
      let formCompleted = true;
      var userData = JSON.parse(localStorage.getItem('web_user'));
      var config = {
        headers: { Authorization: 'Bearer ' + userData['token'] },
      };
      if (userData.token) {
        axios
          .get(
            'user/registration/submitted-forms?user_type_id=' +
              userData['user_type_id'],
            config
          )
          .then((res) => {
            // Mentor
            if( userData['user_type_id'] == 3 ) {
              if (res.data.response.additional_details === false) {
                formCompleted = false;
              }
              if (res.data.response.background === false) {
                formCompleted = false;
              }
              if (res.data.response.faith === false) {
                formCompleted = false;
              }
              if (res.data.response.personal_info === false) {
                formCompleted = false;
              }
              if (res.data.response.question === false) {
                formCompleted = false;
              }
              if (res.data.response.reference === false) {
                formCompleted = false;
              }
            } else {
              if( userData.is_mentor ) {
                // Mentor/Volunteer
                if (res.data.response.additional_details === false) {
                  formCompleted = false;
                }
                if (res.data.response.background === false) {
                  formCompleted = false;
                }
                if (res.data.response.faith === false) {
                  formCompleted = false;
                }
                if (res.data.response.personal_info === false) {
                  formCompleted = false;
                }
                if (res.data.response.question === false) {
                  formCompleted = false;
                }
                if (res.data.response.reference === false) {
                  formCompleted = false;
                }
                if (res.data.response.opportunity === false) {
                  formCompleted = false;
                }
              } else {
                // Volunteer
                if (res.data.response.additional_details === false) {
                  formCompleted = false;
                }
                if (res.data.response.faith === false) {
                  formCompleted = false;
                }
                if (res.data.response.opportunity === false) {
                  formCompleted = false;
                }
                if (res.data.response.personal_info === false) {
                  formCompleted = false;
                }
                if (res.data.response.question === false) {
                  formCompleted = false;
                }
              }
              
            }
            
            if( !formCompleted ) {
              this.backToOverview = false;
            } else {
              this.backToOverview = true;
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message);
            }
          });
      }
    },
    // Getting Current User Information
    getContactDetail() {
      var userData = JSON.parse(localStorage.getItem("web_user"));
      var config = { headers: { Authorization: "Bearer " + userData.token } };
      if (userData.token) {
        axios
          .get("user/profile", config)
          .then((res) => {
            if (res.status == 200) {
              this.addContactInfoForm = res.data.response;
              console.log(this.addContactInfoForm);
              if( this.addContactInfoForm.DOB != null ) {
                this.addContactInfoForm.DOB = moment(this.addContactInfoForm.DOB, 'YYYY-MM-DD').format('MM-DD-YYYY');
                var dob = this.addContactInfoForm.DOB;
                // let newDate = dob.split("/").reverse().join("-");
                // this.addContactInfoForm.DOB = newDate;
                this.calculateAgeWrtDob(dob);
              }
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message);
            }
          });
      }
    },
    calculateAgeFromCalendar(e) {
      this.addContactInfoForm.DOB = moment(e).format('MM-DD-YYYY');
      this.ageError = false;
      this.calculateAgeWrtDob(moment(e).format('MM-DD-YYYY'));
    },
    calculateAge(e) {
      this.addContactInfoForm.DOB = moment(e, 'MM-DD-YYYY').format('MM-DD-YYYY');
      this.ageError = false;
      this.calculateAgeWrtDob(moment(e, 'MM-DD-YYYY').format('YYYY-MM-DD'));
    },
    calculateAgeWrtDob(dob) {
      dob = new Date(dob);
      var diff_ms = Date.now() - dob.getTime();
      var age_dt = new Date(diff_ms);
      this.addContactInfoForm.age = Math.abs(age_dt.getUTCFullYear() - 1970);
      console.log(this.addContactInfoForm.age)
    },
    middleNameValidation(){
      this.isMiddleNameAvailable = this.middleNameAvailability == 'available';
      this.addContactInfoForm.middle_name = this.middleNameAvailability == 'not-available' ? 'NMN' : '';
    },
  },
};
</script>

<style lang="scss">
.input-group-append {

    #dob-datepicker__outer_ {
      height: 100% !important;
    }
  }
.b-form-datepicker {
  padding: 0 !important;
  background-image: none;
  box-shadow: none !important;
  background: none !important;
  border: none !important;

  button#dob-datepicker {
    position: relative !important;
    right: 0 !important;
    top: 0 !important;
    border-top-right-radius: 40px !important;
    border-bottom-right-radius: 40px !important;
  }

  #dob-datepicker {
    position: absolute !important;
    right: 30px !important;
    z-index: 5 !important;
    top: 20px !important;
  }

  #dob-datepicker__dialog_ {
    padding: 0.5rem;

    .b-calendar-header {
      margin-bottom: 0.25rem;

      .form-control {
        padding: 0.25rem !important;
        background-image: none;
        box-shadow: none !important;
        background: none !important;
        border: 1px solid #ced4da;
        font-size: 0.7109375rem !important;
      }
    }

    .b-calendar-nav {
      margin-bottom: 0.25rem;

      .btn {
        padding: 0.25rem;
      }
    }

    .b-calendar-grid {
      padding: 0.25rem;
      margin: 0;
      overflow: hidden;
      border-radius: 6px;
      box-shadow: none;
      border: 1px solid #ced4da;

      .b-calendar-grid-caption {
        padding: 0.25rem;
      }

      .b-calendar-grid-weekdays {
        small {
          font-size: 60%;
        }
      }
    }
  }

  .b-calendar .b-calendar-grid .row {
    flex-wrap: nowrap;
  }
  .no-gutters > .col,
  .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
}
</style>

<template>
  <div>
    <Header></Header>
    <div class="main-body">
      <div id="main-title" class="secondary">
        <div class="container">
          <div class="row mx-0">
            <div class="col-12 col-lg-6 align-self-center">
              <h3 class="title" v-if="userData.is_mentor">
                Mentor / Volunteer Details
              </h3>
              <h3 class="title" v-else>
                {{ userData["user_type_id"] === 3 ? "Mentor" : "Volunteer" }}
                Application
              </h3>
            </div>
            <div
              class="col-12 col-lg-6 text-left text-lg-end align-self-center"
            >
              <p class="need-help">
                Need Help ?
                <a @click="contact" href="javascript:">Contact Us</a>
              </p>
              <!--              <logout-button></logout-button>-->
            </div>
          </div>
        </div>
      </div>
      <div id="create-account">
        <div class="container">
          <div class="row mx-0 justify-content-center">
            <div class="col-12">
              <progressContainer
                  :userData="userData"
                  :active="'contact-info'"
                />
              <!-- <div
                class="progress-container"
                v-if="userData['user_type_id'] === 4"
              >
                <div class="progress-box active">1</div>
                <div class="progress-box">2</div>
                <div class="progress-box">3</div>
                <div class="progress-box">4</div>
                <div class="progress-box">5</div>
              </div>

              <div class="progress-container" v-else>
                <div class="progress-box active">1</div>
                <div class="progress-box">2</div>
                <div class="progress-box">3</div>
                <div class="progress-box">4</div>
                <div class="progress-box">5</div>
                <div class="progress-box">6</div>
              </div> -->
            </div>
          </div>
          <form @submit.prevent="addContactInfo" class="custom-form">
            <div class="row mx-0">
              <div class="col-12 mb-5 text-center">
                <h3 class="main-title">Contact Information</h3>
                <span class="text-center font-size-14"
                  >Fields with a * are required</span
                >
              </div>
              <div class="col-12 col-md-4 mb-4">
                <input
                  v-model="addContactInfoForm.first_name"
                  type="text"
                  class="form-control"
                  placeholder="*Enter First Name"
                  name="first_name"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.first_name.$error,
                  }"
                />
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.first_name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.first_name.required"
                    >First name is required.</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-4 mb-4" v-if="isMiddleNameAvailable">
                <input
                  v-model="addContactInfoForm.middle_name"
                  type="text"
                  class="form-control"
                  placeholder="*Enter Middle Name"
                  name="middleName"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.middle_name.$error,
                  }"
                />
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.middle_name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.middle_name.required"
                    >Middle name is required.</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-4 mb-4">
                <input
                  v-model="addContactInfoForm.last_name"
                  type="text"
                  class="form-control"
                  placeholder="*Enter Last Name"
                  name="lastName"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.last_name.$error,
                  }"
                />
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.last_name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.last_name.required"
                    >Last name is required.</span
                  >
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <!-- v-model="status" -->
              <b-form-checkbox
                v-model="middleNameAvailability"
                size="sm"
                id="middle-name-status"
                name="middle-name-status"
                value="not-available"
                unchecked-value="available"
                @change="middleNameValidation"
              >
              <small>I don't have a middle name</small>
              </b-form-checkbox>
            </div>

            <div class="row mx-0">
              <div class="col-12 col-md-6 mb-4">
                <label class="vt_fields_label" for="dob-datepicker">
                  Date of Birth
                </label>
                <!-- <input
                  v-model="addContactInfoForm.DOB"
                  type="date"
                  class="form-control"
                  placeholder="*DOB"
                  name="DOB"
                  id = "DOB"
                  @change="calculateAge($event)"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.DOB.$error,
                  }"
                /> -->
                <!-- <b-form-datepicker
                  id="dob-datepicker"
                  v-model="addContactInfoForm.DOB"
                  placeholder="DOB *"
                  class=""
                  @input="calculateAge($event)"
                  :date-disabled-fn="dateDisabled"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.DOB.$error,
                  }"
                ></b-form-datepicker> -->
                <b-input-group class="mb-3">
                  <b-form-input
                    id="dob-datepicker2"
                    v-model="addContactInfoForm.DOB"
                    type="text"
                    placeholder="DOB * (MM-DD-YYYY)"
                    autocomplete="off"
                    @change="calculateAge($event)"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                      button-only
                      right
                      locale="en-US"
                      :date-disabled-fn="dateDisabled"
                      aria-controls="dob-datepicker2"
                      id="dob-datepicker"
                      @input="calculateAgeFromCalendar($event)"
                      :value-as-date="true"
                      :date-format-options="{ month: 'numeric', day: 'numeric', year: 'numeric' }"
                      class=""
                      :class="{
                      'is-invalid':
                        typeSubmit && $v.addContactInfoForm.DOB.$error,
                    }"
                    ></b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
                <!-- <small class="d-inline-block ms-4 mt-2 font-size-14" >
                 {{
                  userData['user_type_id'] === 3 ? 'Mentors must be 25 year or older' : ''
                }}
                </small> -->
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.DOB.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.DOB.required"
                    >DOB is required.</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-6 mb-4">
                <label class="vt_fields_label"> Gender </label>
                <b-form-select
                  class="form-select form-control"
                  v-model="addContactInfoForm.gender"
                  :options="gender"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.gender.$error,
                  }"
                >
                  <option slot="first" :value="null" disabled>Gender</option>
                </b-form-select>
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.gender.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.gender.required"
                    >Gender is required.</span
                  >
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="col-12 col-md-12 mb-4 pt-4">
                <input
                  v-model="addContactInfoForm.email"
                  type="text"
                  class="form-control mt-2 pe-none bg-secondary bg-soft"
                  placeholder="*Enter Email Address"
                  name="email"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.email.$error,
                  }"
                />
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.email.required"
                    >Email is required.</span
                  >
                  <span v-if="!$v.addContactInfoForm.email.email"
                    >Invalid Email.</span
                  >
                </div>
              </div>

              <div class="col-12 col-md-6 mb-4">
                <code class="ps-3 pb-3 d-inline-block text-muted font-size-14"
                  >( Please provide the phone number at which you are most
                  easily reached. MnTC will not share your number with third
                  party entities. )</code
                >
                <input
                  v-mask="'###-###-####'"
                  v-model="addContactInfoForm.phone"
                  type="text"
                  class="form-control"
                  placeholder="*Enter Phone Number"
                  name="phone"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.phone.$error,
                  }"
                />
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.phone.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.phone.required"
                    >Phone Number is required.</span
                  >
                  <span v-if="!$v.addContactInfoForm.phone.numeric"
                    >Enter only Numbers.</span
                  >
                </div>
              </div>

              <div class="col-12 col-md-6 mb-4">
                <code class="ps-3 pb-3 d-inline-block text-muted font-size-14"
                  >( Optional - Please provide an Alternate phone number. MnTC
                  will not share your number with third party entities. )
                </code>
                <input
                  v-mask="'###-###-####'"
                  v-model="addContactInfoForm.mobile"
                  type="text"
                  class="form-control"
                  placeholder="Enter Alternate Number (Optional)"
                  name="mobile"
                />
              </div>
            </div>
            <div class="row mx-0">
              <div class="col-12 col-md-6 mb-4">
                <input
                  title="(MnTC uses your address for background check purposes)"
                  v-model="addContactInfoForm.address"
                  type="text"
                  class="form-control"
                  placeholder="*Enter Address"
                  name="address"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.address.$error,
                  }"
                />
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.address.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.address.required"
                    >Address is required.</span
                  >
                </div>
              </div>
              <div class="col-12 col-md-6 mb-4">
                <input
                  v-model="addContactInfoForm.address2"
                  type="text"
                  class="form-control"
                  placeholder="Enter Address (Optional)"
                  name="address2"
                />
              </div>
            </div>
            <div class="row mx-0">
              <div class="col-12 col-md-4 mb-4">
                <input
                  v-model="addContactInfoForm.city"
                  type="text"
                  class="form-control"
                  placeholder="*Enter City"
                  name="city"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.city.$error,
                  }"
                />
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.city.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.city.required"
                    >City is required.</span
                  >
                </div>
              </div>

              <div class="col-12 col-md-4 mb-4">
                <b-form-select
                  class="form-select form-control"
                  v-model="addContactInfoForm.state"
                  :options="states"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.state.$error,
                  }"
                >
                  <option slot="first" :value="null" selected>
                    Select State
                  </option>
                </b-form-select>
                <!-- <small class="d-inline-block ms-4 mt-2 font-size-14">Select State</small> -->

                <!-- <input v-model="addContactInfoForm.state" type="text" class="form-control" placeholder="*Enter State" name="state"
                       :class="{ 'is-invalid': typeSubmit && $v.addContactInfoForm.state.$error }" /> -->
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.state.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.state.required"
                    >State is required.</span
                  >
                </div>
              </div>

              <div class="col-12 col-md-4 mb-4">
                <input
                  v-model="addContactInfoForm.zip_code"
                  type="text"
                  class="form-control"
                  placeholder="*Enter Zip Code"
                  name="zip_code"
                  :class="{
                    'is-invalid':
                      typeSubmit && $v.addContactInfoForm.zip_code.$error,
                  }"
                />
                <div
                  v-if="typeSubmit && $v.addContactInfoForm.zip_code.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.addContactInfoForm.zip_code.required"
                    >Zip Code is required.</span
                  >
                  <span v-if="!$v.addContactInfoForm.zip_code.numeric"
                    >Enter only Numbers.</span
                  >
                </div>
              </div>
            </div>
            <div class="row mx-0">
              <div class="mb-4 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start">
                <b-button v-if="backToOverview" type="button" @click="skipToReview" variant="custom">
                  <i class="font-size-20 me-2 bx bxs-right-arrow-circle"></i>
                  Skip To Review
                </b-button>
                <b-button
                  type="submit"
                  variant="custom"
                  v-if="(userData['user_type_id'] === 4 && !userData.is_mentor)"
                  >Applicant History
                  <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i
                ></b-button>
                <b-button type="submit" variant="custom" v-else
                  >Background Check Information
                  <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i
                ></b-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>